import { Fragment, useState } from 'react';
import {
  Dialog,
  Disclosure,
  Menu,
  Popover,
  Tab,
  Transition,
} from '@headlessui/react';
import {
  Bars3Icon,
  MagnifyingGlassIcon,
  ShoppingBagIcon,
  UserIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';
import {
  ChevronDownIcon,
  FunnelIcon,
  StarIcon,
} from '@heroicons/react/20/solid';
import customFetch from '../../utils/customFetch';
import { useLoaderData } from 'react-router-dom';
import SEO from '../../utils/seo';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const sortOptions = [
  { name: 'Preis: Günstigste oben', href: '#', current: true },
  { name: 'Preis: Teuerste oben', href: '#', current: false },
];

export const loader = async () => {
  try {
    const { data } = await customFetch.get('/products/');
    return data;
  } catch (error) {
    return redirect('/');
  }
};

const ProductGrid = () => {
  const data = useLoaderData();
  const products = data.products;

  return (
    <main className="py-24">
      <SEO
        title="Produkte von sVisit - Die digitale Visitenkarte."
        description="Hier findest du unsere Produkte für deine digitale sVisit-Visitenkarte. Wähle aus der Basic sowie der Custom NFC Visitenkarte."
        type="website"
        image="https://res.cloudinary.com/djvqy2bag/image/upload/v1727613595/sVisit_Basic_Card_2_3_aspect_atitju.png"
      />
      <div className="px-4 py-16 text-center sm:px-6 lg:px-8">
        <h1 className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
          Produkte
        </h1>
        <p className="mx-auto mt-4 max-w-xl text-base text-gray-500">
          Hier findest du unsere Produkte für deine digitale
          sVisit-Visitenkarte.
        </p>
      </div>

      {/* Filter / Sortieren. Filter entfernt, können später wieder eingebaut werden */}
      <Disclosure
        as="section"
        aria-labelledby="filter-heading"
        className="grid items-center border-b border-t border-gray-200"
      >
        <div className="col-start-1 row-start-1 py-4">
          <div className="mx-auto flex max-w-7xl justify-end px-4 sm:px-6 lg:px-8">
            {/* <Menu as="div" className="relative inline-block">
              <div className="flex">
                <Menu.Button className="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
                  Sortieren
                  <ChevronDownIcon
                    className="-mr-1 ml-1 h-5 w-5 shrink-0 text-gray-400 group-hover:text-gray-500"
                    aria-hidden="true"
                  />
                </Menu.Button>
              </div>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-hidden">
                  <div className="py-1">
                    {sortOptions.map((option) => (
                      <Menu.Item key={option.name}>
                        {({ active }) => (
                          <a
                            href={option.href}
                            className={classNames(
                              option.current
                                ? 'font-medium text-gray-900'
                                : 'text-gray-500',
                              active ? 'bg-gray-100' : '',
                              'block px-4 py-2 text-sm'
                            )}
                          >
                            {option.name}
                          </a>
                        )}
                      </Menu.Item>
                    ))}
                  </div>
                </Menu.Items>
              </Transition>
            </Menu> */}
          </div>
        </div>
      </Disclosure>

      {/* Product grid */}
      <section
        aria-labelledby="products-heading"
        className="mx-auto max-w-7xl overflow-hidden sm:px-6 lg:px-8"
      >
        <h2 id="products-heading" className="sr-only">
          Products
        </h2>

        <div className="-mx-px grid grid-cols-2 border-l border-gray-200 sm:mx-0 md:grid-cols-3 lg:grid-cols-4">
          {products.map((product) => (
            <div
              key={product._id}
              className="group relative border-b border-r border-gray-200 p-4 sm:p-6"
            >
              <div className="aspect-h-1 aspect-w-1 overflow-hidden rounded-lg bg-gray-200 group-hover:opacity-75">
                <img
                  src={product.image}
                  alt={product.name}
                  className="h-full w-full object-cover object-center"
                />
              </div>
              <div className="pb-4 pt-10 text-center">
                <h3 className="text-sm font-medium text-gray-900">
                  <a href={`produkte/${product._id}`}>
                    <span aria-hidden="true" className="absolute inset-0" />
                    {product.name}
                  </a>
                </h3>
                {/* Reviews für später */}
                {/* <div className="mt-3 flex flex-col items-center">
                  <p className="sr-only">{product.rating} out of 5 stars</p>
                  <div className="flex items-center">
                    {[0, 1, 2, 3, 4].map((rating) => (
                      <StarIcon
                        key={rating}
                        className={classNames(
                          product.rating > rating
                            ? 'text-yellow-400'
                            : 'text-gray-200',
                          'h-5 w-5 shrink-0'
                        )}
                        aria-hidden="true"
                      />
                    ))}
                  </div>
                  <p className="mt-1 text-sm text-gray-500">
                    {product.reviewCount} reviews
                  </p>
                </div> */}
                <p className="mt-4 text-base font-medium text-gray-900">
                  CHF {product.price / 100}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Pagination für später, in TailwindUI nachschauen */}
    </main>
  );
};

export default ProductGrid;
